// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wIa1kt {
  width: 100%;
  height: 100%;
  min-width: 600px;
  background-color: var(--background-white, #ffffff);
  border-radius: var(--radius-xs, 4px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
}

.j0rkmw {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  table-layout: auto;
  font-size: 14px;
  border-radius: 8px;
  flex: 1;
  flex-direction: column;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
}

.j0rkmw tbody tr:nth-of-type(odd) {
  background: #f9fafc;
}

.j0rkmw tbody tr:nth-of-type(even) {
  background: #ffffff;
}

.Sgaq0O {
  display: flex;
  align-items: center;
  gap: var(--spacing-3, 24px);
  padding: var(--spacing-1-5, 12px) var(--spacing-1-5, 12px) 0 var(--spacing-1-5, 12px);
  border-bottom: 1px solid var(--border-neutral-light, #e5e5e5);
}

.dx2NVq {
  cursor: pointer;
  padding: var(--spacing-1, 8px);
  text-align: center;
  font-size: var(--font-size-md, 14px);
  color: var(--surface-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-regular, 400);
  vertical-align: middle;
}

.Y1D5tn {
  color: var(--primary-orange-500, #d64000);
  font-weight: var(--font-weight-semibold, 600);
  border-bottom: 2px solid var(--primary-orange-500, #d64000);
}

.OL6UVq {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.LT9Gz9 {
  cursor: not-allowed;
  width: 16px;
  height: 16px;
  color: var(--border-neutral-light, #d9d9d9);
  opacity: 0.5;
}

.FHgag0 {
  max-width: 304px;
  margin-bottom: var(--spacing-1, 8px);
}

.Ykwg4u {
  height: 100%;
  margin: var(--spacing-3, 24px);
}

.abnjrd {
  flex: 1;
  height: 100%;
  max-height: calc(100% - 42px);
  overflow-y: auto;
}

th {
  padding: var(--spacing-2, 16px);
  text-align: left;
  font-size: var(--type-label-md-font-size, 14px);
  color: var(--surface-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-semibold, 600);
  margin: 0;
}

tr {
  padding: var(--spacing-2, 16px);
  text-align: left;
  font-size: var(--type-label-md-font-size, 14px);
  color: var(--surface-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-regular, 400);
  margin: 0;
  border-radius: var(--radius-xs, 4px);
}

.j0rkmw tbody tr.QeVth0:hover,
.j0rkmw tbody tr.QeVth0:focus {
  background-color: var(--color-background-hover, rgba(255, 102, 0, 0.05)) !important;
  cursor: pointer;
}

td {
  color: #1f1f1f;
  padding: var(--spacing-2, 16px);
}

.nP3QoS {
  max-width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.XyRqXQ {
  width: 120px;
  text-align: center;
  align-items: center;
}

.RIhEY9 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

._qdNyS {
  padding: var(--spacing-3, 24px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  border-top: 1px solid var(--border-neutral-light, #e5e5e5);
}

.Ip9uW6 {
  font-size: var(--type-label-md-font-size, 14px);
  color: var(--surface-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-regular, 400);
  display: flex;
  gap: var(--spacing-1-5, 12px);
  align-items: center;
}

.Bu3KBi {
  font-size: var(--type-label-md-font-size, 14px);
  color: var(--surface-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-semibold, 600);
}

.YxhiLY {
  height: 100%;
  display: flex;
  justify-content: center;
}

.GZ7wDX {
  padding: var(--spacing-2, 16px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.zIfgro {
  height: 5px;
  /* Invisible trigger element that becomes visible when user scrolls to bottom */
  pointer-events: none;
}

.WWf3PO {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-0-25, 3px) var(--spacing-0-75, 6px);
  border-radius: var(--radius-sm, 4px);
  border: 1px solid;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-sm, 12px);
  color: var(--surface-neutral-dark, #1f1f1f);
  white-space: nowrap;
}

.WWf3PO.J0YDKU {
  background-color: var(--success-background, #eef8ec);
  border-color: var(--success-border, #387c2b);
}

.WWf3PO.e2lrLt {
  background-color: var(--error-background, #fee7e7);
  border-color: var(--error-border, #dc0a0a);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/pages/Instructions/Instructions.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kDAAkD;EAClD,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qFAAqF;EACrF,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,2DAA2D;AAC7D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,+CAA+C;EAC/C,2CAA2C;EAC3C,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,+CAA+C;EAC/C,2CAA2C;EAC3C,4CAA4C;EAC5C,SAAS;EACT,oCAAoC;AACtC;;AAEA;;EAEE,mFAAmF;EACnF,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,4CAA4C;EAC5C,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,+EAA+E;EAC/E,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;EAC1D,oCAAoC;EACpC,iBAAiB;EACjB,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;EAClD,0CAA0C;AAC5C","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n  min-width: 600px;\n  background-color: var(--background-white, #ffffff);\n  border-radius: var(--radius-xs, 4px);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n}\n\n.table {\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  table-layout: auto;\n  font-size: 14px;\n  border-radius: 8px;\n  flex: 1;\n  flex-direction: column;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n}\n\n.table tbody tr:nth-of-type(odd) {\n  background: #f9fafc;\n}\n\n.table tbody tr:nth-of-type(even) {\n  background: #ffffff;\n}\n\n.navBar {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-3, 24px);\n  padding: var(--spacing-1-5, 12px) var(--spacing-1-5, 12px) 0 var(--spacing-1-5, 12px);\n  border-bottom: 1px solid var(--border-neutral-light, #e5e5e5);\n}\n\n.navButton {\n  cursor: pointer;\n  padding: var(--spacing-1, 8px);\n  text-align: center;\n  font-size: var(--font-size-md, 14px);\n  color: var(--surface-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-regular, 400);\n  vertical-align: middle;\n}\n\n.active {\n  color: var(--primary-orange-500, #d64000);\n  font-weight: var(--font-weight-semibold, 600);\n  border-bottom: 2px solid var(--primary-orange-500, #d64000);\n}\n\n.tableColumnActionIcons {\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n}\n\n.tableColumnActionIconsDisabled {\n  cursor: not-allowed;\n  width: 16px;\n  height: 16px;\n  color: var(--border-neutral-light, #d9d9d9);\n  opacity: 0.5;\n}\n\n.searchInput {\n  max-width: 304px;\n  margin-bottom: var(--spacing-1, 8px);\n}\n\n.mainTable {\n  height: 100%;\n  margin: var(--spacing-3, 24px);\n}\n\n.content {\n  flex: 1;\n  height: 100%;\n  max-height: calc(100% - 42px);\n  overflow-y: auto;\n}\n\nth {\n  padding: var(--spacing-2, 16px);\n  text-align: left;\n  font-size: var(--type-label-md-font-size, 14px);\n  color: var(--surface-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-semibold, 600);\n  margin: 0;\n}\n\ntr {\n  padding: var(--spacing-2, 16px);\n  text-align: left;\n  font-size: var(--type-label-md-font-size, 14px);\n  color: var(--surface-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-regular, 400);\n  margin: 0;\n  border-radius: var(--radius-xs, 4px);\n}\n\n.table tbody tr.clickable:hover,\n.table tbody tr.clickable:focus {\n  background-color: var(--color-background-hover, rgba(255, 102, 0, 0.05)) !important;\n  cursor: pointer;\n}\n\ntd {\n  color: #1f1f1f;\n  padding: var(--spacing-2, 16px);\n}\n\n.colBeneficiary {\n  max-width: 320px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.colAction {\n  width: 120px;\n  text-align: center;\n  align-items: center;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.footer {\n  padding: var(--spacing-3, 24px);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: row;\n  border-top: 1px solid var(--border-neutral-light, #e5e5e5);\n}\n\n.footerLeft {\n  font-size: var(--type-label-md-font-size, 14px);\n  color: var(--surface-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-regular, 400);\n  display: flex;\n  gap: var(--spacing-1-5, 12px);\n  align-items: center;\n}\n\n.footerMoney {\n  font-size: var(--type-label-md-font-size, 14px);\n  color: var(--surface-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-semibold, 600);\n}\n\n.loadingContainer {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.loadingMoreContainer {\n  padding: var(--spacing-2, 16px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loadMoreTrigger {\n  height: 5px;\n  /* Invisible trigger element that becomes visible when user scrolls to bottom */\n  pointer-events: none;\n}\n\n.statusPill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-0-25, 3px) var(--spacing-0-75, 6px);\n  border-radius: var(--radius-sm, 4px);\n  border: 1px solid;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-sm, 12px);\n  color: var(--surface-neutral-dark, #1f1f1f);\n  white-space: nowrap;\n}\n\n.statusPill.approved {\n  background-color: var(--success-background, #eef8ec);\n  border-color: var(--success-border, #387c2b);\n}\n\n.statusPill.reproved {\n  background-color: var(--error-background, #fee7e7);\n  border-color: var(--error-border, #dc0a0a);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `wIa1kt`,
	"table": `j0rkmw`,
	"navBar": `Sgaq0O`,
	"navButton": `dx2NVq`,
	"active": `Y1D5tn`,
	"tableColumnActionIcons": `OL6UVq`,
	"tableColumnActionIconsDisabled": `LT9Gz9`,
	"searchInput": `FHgag0`,
	"mainTable": `Ykwg4u`,
	"content": `abnjrd`,
	"clickable": `QeVth0`,
	"colBeneficiary": `nP3QoS`,
	"colAction": `XyRqXQ`,
	"loading": `RIhEY9`,
	"footer": `_qdNyS`,
	"footerLeft": `Ip9uW6`,
	"footerMoney": `Bu3KBi`,
	"loadingContainer": `YxhiLY`,
	"loadingMoreContainer": `GZ7wDX`,
	"loadMoreTrigger": `zIfgro`,
	"statusPill": `WWf3PO`,
	"approved": `J0YDKU`,
	"reproved": `e2lrLt`
};
module.exports = ___CSS_LOADER_EXPORT___;
